module.exports = __webpack_public_path__ + "fonts/helvetica-neue-lt-pro-bold.9b655940.ttf";